import { Empty, Input, Form } from 'antd';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { SubjectBlocksProps, TimetableDraggableItem } from '@modules/timetable';
import { useMst } from '@models/Root';
import { TimelineItemTypeType } from '@app-types/timetable';
import dynamic from 'next/dynamic';
import { ChangeEvent, useState } from 'react';
import _ from 'lodash';
import { SearchOutlined } from '@ant-design/icons';

const SimpleBar = dynamic(() => import('simplebar-react'));

export const SubjectSlotContainer = styled.div`
  display: flex;

  .site-badge {
    left: 12px;
  }
`;

export const SubjectBlocks = observer(({ batchSubjects }: SubjectBlocksProps) => {
  const { timetableSlotCounts, classId } = useMst().timetable;
  const [batchSubjectList, setBatchSubjectList] = useState(batchSubjects);

  if (batchSubjects.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a semester and batch first" />;
  }
  return (
    <>
      <Form.Item>
        <Input
          style={{ width: '300px' }}
          placeholder="Search subject code"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            if (event.target.value) {
              setBatchSubjectList(() => {
                let filteredArray = [];
                filteredArray = batchSubjects.filter((batchClass) =>
                  batchClass.subject.code.toLowerCase().includes((event.target.value as string).toLowerCase()),
                );
                return _.isEmpty(filteredArray) ? [] : filteredArray;
              });
            } else {
              setBatchSubjectList(batchSubjects);
            }
          }}
          suffix={<SearchOutlined />}
        />
      </Form.Item>

      <SimpleBar style={{ maxHeight: 134 }}>
        {batchSubjectList.map((batchSubject) => {
          // Check classId and subjectId is equal to the timetableSlot data and then get each slot
          const timetableSubjectSlotCountIndex = timetableSlotCounts.findIndex(
            (timetableSlot) => timetableSlot.id === batchSubject.id && timetableSlot.classId === classId,
          );

          const timetableSubjectSlotCount = timetableSlotCounts[timetableSubjectSlotCountIndex];

          return (
            batchSubject.subject && (
              <SubjectSlotContainer key={batchSubject.id}>
                <TimetableDraggableItem
                  id={batchSubject.id}
                  totalSlots={
                    timetableSubjectSlotCount?.availableSlotCount > 0
                      ? timetableSubjectSlotCount?.availableSlotCount
                      : 0
                  }
                  hoursPerSlot={parseFloat(`${batchSubject.hoursPerSlot}.${batchSubject.minutesPerSlot}`)}
                  slotCode={batchSubject.subject.code}
                  slotName={batchSubject.subject.name}
                  slotColor={batchSubject.subject.color}
                  type={TimelineItemTypeType.subject}
                />
                {batchSubject.batch_subject_extra_slots.map((subjectExtra) => {
                  // Check classId and subjectExtraId is equal to the timetableSlot data and then get each slot
                  const timetableSubjectExtraSlotCountIndex = timetableSlotCounts.findIndex(
                    (timetableSlot) => timetableSlot.id === subjectExtra.id && timetableSlot.classId === classId,
                  );

                  const timetableSubjectExtraSlotCount = timetableSlotCounts[timetableSubjectExtraSlotCountIndex];

                  return (
                    batchSubject.subject && (
                      <div key={subjectExtra.id}>
                        <TimetableDraggableItem
                          id={subjectExtra.id}
                          slotName={batchSubject.subject.name}
                          totalSlots={
                            timetableSubjectExtraSlotCount?.availableSlotCount > 0
                              ? timetableSubjectExtraSlotCount?.availableSlotCount
                              : 0
                          }
                          hoursPerSlot={parseFloat(`${subjectExtra.hoursPerSlot}.${subjectExtra.minutesPerSlot}`)}
                          slotCode={subjectExtra.name}
                          slotColor={batchSubject.subject.color}
                          type={TimelineItemTypeType.extra}
                        />
                      </div>
                    )
                  );
                })}
              </SubjectSlotContainer>
            )
          );
        })}
      </SimpleBar>
    </>
  );
});
